import course from './course-page.json';
import lesson from './lesson-page.json';
import learningActivity from './learning-activity-page.json';
import cookies from './cookies.json';
import toast from './toast.json';
import actions from './actions.json';

export const commonSources = {
  ...cookies,
  ...toast,
  ...actions,
};

export const coursePageSources = {
  ...course,
  ...commonSources,
};

export const lessonPageSources = {
  ...lesson,
  ...commonSources,
};

export const learningActivityPageSources = {
  ...learningActivity,
  ...commonSources,
};

export const allSources = {
  ...course,
  ...lesson,
  ...learningActivity,
  ...commonSources,
};
